import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/general.scss';
import 'bootstrap/dist/js/bootstrap.bundle'; // Import Bootstrap JS bundle
// import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'jquery';
import '@popperjs/core';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initMatomo } from 'services/api-client/matomoTracker';

// Queue the Matomo configuration and start fetching matomo.js before React
// mounts, so heatmap/session recording is armed for the first paint. No-op
// until REACT_APP_MATOMO_URL is configured. Page views come from the router.
initMatomo();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
